import template from './form.html';
import { FormActions } from 'core/services/form';
import { rest } from 'core/api';
import cajasI18N from 'i18n/cajas/es.json';
import commonI18N from 'i18n/common/es.json';
import { fechaHoraRenderer } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let CerrarCajaForm = {
  templateUrl: template,
  selector: 'cerrarCajaForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(cajasI18N).concat(Object.keys(commonI18N));


FormController.$inject = [
  '$state', '$scope', '$filter', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', '$timeout', 'localStorageService', 'CustomModal'
];

function FormController($state, $scope, $filter, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, $timeout, localStorageService, CustomModal) {
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.doSubmit = doSubmit.bind(this);

  this.updateValor = updateValor.bind(this);

  this.cancel = cancel.bind(this);

  const valoresFilter = Filter.path('tipo.codigo').eq('denominaciones_guarani');
  const parametroFilter = Filter.path('codigo').eq('declaracion_efectivo');

  let unsubscribe;
  this.$onDestroy = () => {
    this.form();
    $ngRedux.dispatch(rest.actions.valores.reset());
    $ngRedux.dispatch(rest.actions.parametros.reset());
    unsubscribe();
  };


  this.localModel = {
    cierre: {},
    valores: {}
  };

  this.$onInit = () => {
    ngNotify.dismiss();
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    let caja = localStorageService.get('caja');

    this.localModel.caja = caja;
    if (!caja) {
      ngNotify.set(this.translations['Debe asignar una caja al equipo'], 'warn');
      $state.go('home.cajas.list');
      return;
    } else if (caja.sesionActual && caja.sesionActual.estado.value !== 'Abierta') {
      ngNotify.set(this.translations['La caja no está abierta'], 'warn');
      $state.go('home.cajas.list');
      return;
    } else if (caja && caja.id) {
      this.formEdit('cajas', caja.id);
    }

    this.localModel.fechaApertura = fechaHoraRenderer(this.localModel.caja.sesionActual.fechaInicio);
    this.localModel.fechaCierre = fechaHoraRenderer(new Date()); //.format('DD/MM/YYYY hh:mm');
    this.localModel.usuarioApertura = `${this.localModel.caja.sesionActual.usuarioApertura.nombre} ${this.localModel.caja.sesionActual.usuarioApertura.apellido}`;
    this.localModel.montoInicial = $filter('currency')(this.localModel.caja.sesionActual.montoInicial, 'Gs.', 0);
    this.localModel.montoNotaCredito = 0;
    this.localModel.montoRetencion = 0;
    this.title = this.translations['Cierre de Caja'];
    $ngRedux.dispatch(rest.actions.parametros.get({ filter: JSON.stringify(parametroFilter) }));
    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));

  };

  this.submitted = false;

  function mapStateToThis(state) {
    this.handleStatus(state);

    this.model = state.form.model;

    if (state.currentUser) {
      this.user = state.currentUser.data;
      this.localModel.usuarioCierre = `${this.user.nombre} ${this.user.apellido}`;

    }

    if (state.parametros.data && state.parametros.data.length === 1) {
      let parametro = state.parametros.data[0];
      if (parametro && parametro.valor.value === 'SI') {
        this.localModel.declaracion = true;
      } else {
        this.localModel.declaracion = false;
      }
    }
    if (state.valores.data && state.valores.data.length > 0) {
      let valores = {};
      state.valores.data.forEach(function(item) {
        item.value = item.value.replace('.', '');
        valores[item.id] = {
          valor: {
            id: item.id
          },
          cantidad: 0,
          importe: 0
        };
      });
      this.localModel.valores = valores;
    }

    return {
      form: state.form,
      denominaciones: state.valores.data.filter((v) => v.tipo.codigo === 'denominaciones_guarani')
    };
  }

  function updateValor(detalle, cantidad) {
    let valor = parseInt(detalle.value);
    if (typeof valor === 'number' && typeof cantidad === 'number')
      this.localModel.valores[detalle.id].importe = cantidad * valor;
  }


  /**
   * Función que se encarga de mostrar mensajes de error/exito en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe la caja asociada al equipo']} ${this.localModel.caja.nombre}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.cajas.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      this.cobrarFacturaNotify(state.form.created);
      $state.go('home.cajas.list');
    }
  }

  function doSubmit() {
    let self = this;
    let valores = this.localModel.valores;
    let valoresArray = [];
    this.denominaciones.forEach(function(item) {
      if (valores[item.id].cantidad === undefined) {
        ngNotify.set(self.translations['Debe declarar todas las denominaciones'], 'warn');
        return;
      }
      valoresArray.push(valores[item.id]);
    });

    let arqueo = {};
    if (this.localModel.declaracion) {
      arqueo.valores = valoresArray;
      arqueo.montoNotaCredito = this.localModel.montoNotaCredito;
      arqueo.montoRetencion = this.localModel.montoRetencion;
    } else {
      arqueo.montoFinal = this.localModel.montoFinal;
      arqueo.montoNotaCredito = this.localModel.montoNotaCredito;
      arqueo.montoRetencion = this.localModel.montoRetencion;
    }


    $ngRedux.dispatch(rest.actions.cerrarCaja({ id: this.localModel.caja.id }, {
      body: JSON.stringify(arqueo)
    }, (err, data) => {
      if (!err && data.sesionActual.estado.value === 'Cerrada') {
        //ngNotify.set(self.translations['Cerrada Correctamente'], 'success');

        localStorageService.set('caja', { id: data.id, numero: data.numero, nombre: data.nombre, sesionActual: data.sesionActual, puntoEmision: data.puntoEmision });
        $state.go('home.cajas.list', { cid: data.id });
      } else if (err) {
        ngNotify.set(err.message, 'warn');
      }
    }));
  }

  function cancel() {
    $state.go('home.cajas.list');
  }


}



// WEBPACK FOOTER //
// ./src/components/cajas/cerrar/form.component.js